<template>
  <div
    :class="[
      $blockClass(blockClass, 'accordion'),
      { [$class('open')]: active },
    ]"
    class="basic-accordion"
  >
    <button
      :class="[
        $blockClass(blockClass, 'accordion-header'),
      ]"
      class="basic-accordion__header"
      @click="$emit('toggle-accordion', id)"
    >
      <h2
        v-if="title"
        :class="[
          $blockClass(blockClass, 'accordion-title'),
        ]"
        class="basic-accordion__title"
        v-text="title"
      />

      <span v-if="active">
        <slot
          v-if="$slots['closeIcon']"
          name="closeIcon"
        />

        <icon-minus v-else />
      </span>

      <span v-else>
        <icon-add />
      </span>
    </button>

    <component
      :is="transition ? 'transition-height' : 'div'"
    >
      <div
        v-show="active"
        :class="[
          $blockClass(blockClass, 'accordion-content'),
        ]"
        class="basic-accordion__content"
      >
        <slot name="content" />
      </div>
    </component>
  </div>
</template>

<script>

/**
 * Vue: Basic accordion (basic-accordion)
 * -----------------------------------------------------------------------------
 * Basic accordion that allows for a title and html to be passed in.
 *
 * @param {String} [title] - Title of accordion.
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {String} [content] - Content of accordion.
 * @param {Boolean} [transition] - Transition on open/close of accordion.
 *
 */
import IconAdd from '~icons/misc/add.svg'
import IconMinus from '~icons/misc/minus.svg'

import TransitionHeight from '~global/transition-height/transition-height'


export default {
  name: 'BasicAccordion',

  components: {
    IconAdd,
    IconMinus,
    TransitionHeight,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    blockClass: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    transition: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['toggle-accordion'],
}
</script>

<style lang="scss">
@import './basic-accordion';
</style>
